const statusConfig = {
  pending: { bg: "bg-amber-50", text: "text-amber-700", border: "border-amber-200", label: "Pending" },
  under_review: { bg: "bg-blue-50", text: "text-blue-700", border: "border-blue-200", label: "Under Review" },
  approved: { bg: "bg-green-50", text: "text-green-700", border: "border-green-200", label: "Approved" },
  denied: { bg: "bg-red-50", text: "text-red-700", border: "border-red-200", label: "Denied" },
  completed: { bg: "bg-emerald-50", text: "text-emerald-700", border: "border-emerald-200", label: "Completed" },
  scheduled: { bg: "bg-blue-50", text: "text-blue-700", border: "border-blue-200", label: "Scheduled" },
  cancelled: { bg: "bg-red-50", text: "text-red-700", border: "border-red-200", label: "Cancelled" },
  active: { bg: "bg-green-50", text: "text-green-700", border: "border-green-200", label: "Active" },
};

export default function StatusBadge({ status }) {
  const config = statusConfig[status] || statusConfig.pending;
  return (
    <span className={`inline-flex px-2.5 py-0.5 rounded-full text-xs font-semibold border ${config.bg} ${config.text} ${config.border}`} data-testid="status-badge">
      {config.label}
    </span>
  );
}
